(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    const components = document.querySelectorAll('slideshow-component[data-custom-autoplay]');

    if (!components.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    components.forEach((component) => {
      const seconds = parseInt(component.getAttribute('data-autoplay-speed'), 10) || 4;
      const intervalMs = seconds * 1000;
      let timer;

      const step = () => {
        if (component.matches(':hover') || document.hidden) return;

        if (component.atEnd) {
          component.select(0);
        } else {
          component.next();
        }
      };

      const start = () => {
        if (timer) return;
        timer = setInterval(step, intervalMs);
      };

      const stop = () => {
        clearInterval(timer);
        timer = undefined;
      };

      component.addEventListener('pointerdown', stop);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    const sections = document.querySelectorAll('main#MainContent > .shopify-section');

    if (!sections.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach((section) => section.classList.add('scroll-revealed'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  })();
  } catch(e) { console.error(e); }
})();

})();
